export const CARD_MEDIUM_PHYSICAL = 'physical';
export const CARD_MEDIUM_DIGITAL = 'digital';

export const RECIPIENT_COUNT_MULTIPLE = 'multiple';
export const RECIPIENT_COUNT_SINGLE = 'one';

export const RECIPIENT_TYPE_SOMEONE_ELSE = 'friend';
export const RECIPIENT_TYPE_SELF = 'self';

export const RECIPIENT_METHOD_MANUAL = 'manual';
export const RECIPIENT_METHOD_BULK = 'bulk';

export const CARD_DESIGN_CUSTOM = 'custom';

export enum STEPS {
  TYPE = 'Type',
  VALUE = 'Value',
  RECIPIENT = 'Recipient',
  MESSAGE = 'Message',
  DESIGN = 'Design',
  SEND = 'Send',
  CONFIRM = 'Confirm',
}

export enum MULTICHOICE_CARD_REDEMPTION_STEPS {
  RETAILER = 'Retailer',
  DETAILS = 'Details',
  ACTIVATE = 'Activate',
}

export const MULTICHOICE_REDEMPTION_STEPS = [MULTICHOICE_CARD_REDEMPTION_STEPS.RETAILER, MULTICHOICE_CARD_REDEMPTION_STEPS.DETAILS, MULTICHOICE_CARD_REDEMPTION_STEPS.ACTIVATE];

// The product type strings must correspond to the product type values used in the Shopify Admin.
// The product type is found via the Storefront API `productType` field.
// https://shopify.dev/api/storefront/reference/products/product
export enum PRODUCT_TYPE {
  OPEN_LOOP_CARD = 'Open Loop Card',
  EGIFT_VOUCHER_CARD = 'eGift Voucher',
  MULTICHOICE_CARD = 'Multichoice',
  MERCHANT_CATEGORY = 'Merchant Category',
  CARD_DOT_GIFT_CARD = 'Card.Gift Card',
  UNKNOWN = 'Unknown',
}

export const PRODUCT_TYPE_OPEN_LOOP_CARD = 'Open Loop Card';
export const PRODUCT_TYPE_EGIFT_VOUCHER_CARD = 'eGift Voucher';
export const PRODUCT_TYPE_MULTICHOICE_CARD = 'Multichoice';
export const PRODUCT_TYPE_MERCHANT_CATEGORY = 'Merchant Category';
export const PRODUCT_TYPE_CARD_DOT_GIFT_CARD = 'Card.Gift Card';

export enum REDEEM_SCREEN_STYLE {
  EGIFT_VOUCHER_CARD,
  CARD_DOT_GIFT_CARD,
  STREAMLINED,
}

export enum PRODUCT_HANDLE {
  EFTPOS = 'eftpos',
  MASTER_CARD = 'mastercard',
  CARD_GIFT = 'carddotgift',
  MASTER_CARD_CUSTOM = 'mastercard-custom',
  EFTPOS_CARD_CUSTOM = 'eftpos-custom',
  CARDDOTGIFT_CARD_CUSTOM = 'carddotgift-custom',
}

export enum COLLECTION_HANDLE {
  MULTI_CHOICE_CARDS = 'multi-choice-cards',
  MASTER_CARD = 'mastercard',
  MASTER_CARD_AND_EFTPOS_CARDS = 'mastercard-and-eftpos-cards',
  E_GIFT_VOUCHER = 'e-gift-voucher',
  CARD_GIFT_CREDIT = 'card-gift-credit',
  EXPERIENCE_CARDS = 'experience-cards',
}

export const cardByTypeCollectionHandles = [
  COLLECTION_HANDLE.MULTI_CHOICE_CARDS,
  // COLLECTION_HANDLE.MASTER_CARD, // Temporarily disabled while TCN negotiate contracts with Mastercard. TCN-860.
  COLLECTION_HANDLE.MASTER_CARD_AND_EFTPOS_CARDS, // Temporarily added while TCN negotiates with Mastercard. TCN-860.
  COLLECTION_HANDLE.E_GIFT_VOUCHER,
  COLLECTION_HANDLE.CARD_GIFT_CREDIT,
  COLLECTION_HANDLE.EXPERIENCE_CARDS,
];

export const redemptionCardByTypeCollectionHandles = [
  COLLECTION_HANDLE.MULTI_CHOICE_CARDS,
  // COLLECTION_HANDLE.MASTER_CARD, // Temporarily disabled while TCN negotiate contracts with Mastercard. TCN-860.
  COLLECTION_HANDLE.MASTER_CARD_AND_EFTPOS_CARDS, // Temporarily added while TCN negotiates with Mastercard. TCN-860.
  COLLECTION_HANDLE.E_GIFT_VOUCHER,
  // COLLECTION_HANDLE.CARD_GIFT_CREDIT, // Remove Card.Gift as that is what you've got...
  COLLECTION_HANDLE.EXPERIENCE_CARDS,
];

// export type CGCardType = 'Open Loop Card' | 'eGift Voucher' | 'Multichoice' | 'Merchant Category' | 'Card.Gift Card';
export type CGCardType =
  | PRODUCT_TYPE.OPEN_LOOP_CARD
  | PRODUCT_TYPE.EGIFT_VOUCHER_CARD
  | PRODUCT_TYPE.MULTICHOICE_CARD
  | PRODUCT_TYPE.MERCHANT_CATEGORY
  | PRODUCT_TYPE.CARD_DOT_GIFT_CARD
  | PRODUCT_TYPE.UNKNOWN;

// video upload
export const UPLOAD_HELPER_TEXT = 'Maximum file size is 50MB, maximum video length is one minute.';
export const MAX_VIDEO_SIZE_MB = 50;
export const VIDEO_SIZE_ERROR = `Video file must not be greater than ${MAX_VIDEO_SIZE_MB} MB`;
export const VIDEO_FILE_TYPES = ['video/mp4', 'video/quicktime'];

// image upload
export const IMAGE_FILE_TYPES = ['image/png', 'image/jpeg'];
export const MIN_IMAGE_WIDTH = 640;
export const MIN_IMAGE_HEIGHT = 480;
export const MAX_IMAGE_SIZE_MB = 3;
export const IMAGE_SIZE_ERROR = `Image file must not be greater than ${MAX_IMAGE_SIZE_MB}MB`;
export const IMAGE_DIMENSION_ERROR = `Image dimension must not be less than ${MIN_IMAGE_WIDTH}x${MIN_IMAGE_HEIGHT}`;
export const IMAGE_REQUIREMENT_TEXT = `Image must be at least ${MIN_IMAGE_WIDTH}x${MIN_IMAGE_HEIGHT} and one of these formats: jpg, gif, png. We review each image submitted.`;
export const BULK_RECIPIENTS_TEMPLATE = ['Name,Email,Phone,Message', 'Your Name,your_email@gmail.com,0407123456'];

// error message
export const serverErrorMessage = "Sorry! We're experiencing a server error right now. Please try again.";
